export function setHeaderHeight() {
    const header = document.querySelector('.site-header');
    if (header) {
      const height = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }
  
  export function handleResize() {
    setHeaderHeight();
  }
  
